// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderDataContainer_container__1qk-L","loader":"LoaderDataContainer_loader__1ym6g","spin":"LoaderDataContainer_spin__2C0Kj"};